import { useEffect, useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";

const hiddenMenuRoutes = ["/checkout", "/checkout/order-pay/:orderId"];

const useLayout = () => {
  const location = useLocation();

  const isNavigationHidden = useMemo(
    () => hiddenMenuRoutes.some((route) => matchPath(route, location.pathname)),
    [location.pathname],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return { isNavigationHidden };
};

export default useLayout;
